export const Token_Key = "oasissgr_access_token"


export const openFile = (fileId) => {
    window.open(`https://drive.google.com/file/d/${fileId}/view`, '_blank');
  };

 